<div class="row" fxLayout="row" fxLayoutAlign="space-between baseline">
    <div>{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_GROSS' | translate }}:</div>
    <div>{{ data.totalGross | currency : data.currency:'symbol-narrow' }}</div>
</div>
<div
    class="row"
    fxLayout="row"
    fxLayoutAlign="space-between baseline"
    *ngIf="data.totalDiscount"
>
    <div>{{ 'CONFIGURATION.PANEL.LABEL.PACKAGE_PRICE_ADVANTAGE' | translate }}:</div>
    <div class="discount">
        - {{ data.totalDiscount | currency : data.currency:'symbol-narrow' }}
    </div>
</div>

<div
    class="row"
    fxLayout="row"
    fxLayoutAlign="space-between baseline"
    *ngIf="data.totalDiscount && data.totalPrice"
>
    <div>{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_PRICE' | translate }}:</div>
    <div>{{ data.totalPrice | currency : data.currency:'symbol-narrow' }}</div>
</div>

<div
    class="row total"
    fxLayout="row"
    fxLayoutAlign="space-between baseline"
    *ngIf="data.netPrice"
>
    <div>{{ 'CONFIGURATION.PANEL.LABEL.NET_PRICE' | translate }}:</div>
    <div>{{ data.netPrice | currency : data.currency:'symbol-narrow' }}</div>
</div>
